/* src/app/shared/shop/product-card/product-label/product-label.component.scss */
.label {
  position: absolute;
  top: 6px;
  left: 6px;
  display: flex;
  column-gap: 5px;
  row-gap: 2px;
  flex-wrap: wrap;
}
.label.relativePosition {
  position: relative !important;
  top: unset;
  left: unset;
}
.chip-base,
.chip-color-danger,
.chip-color-warning,
.chip-color-tertiary,
.chip-color-secondary,
.chip-color-primary,
.chip-color-dark {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  height: fit-content;
  border-radius: 20px;
  letter-spacing: 0.2px;
  padding: 8px 16px 8px 16px;
}
.chip-base span,
.chip-color-danger span,
.chip-color-warning span,
.chip-color-tertiary span,
.chip-color-secondary span,
.chip-color-primary span,
.chip-color-dark span {
  font-size: 1rem;
}
.chip-base ion-icon,
.chip-color-danger ion-icon,
.chip-color-warning ion-icon,
.chip-color-tertiary ion-icon,
.chip-color-secondary ion-icon,
.chip-color-primary ion-icon,
.chip-color-dark ion-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  display: block !important;
}
.chip-base.small,
.small.chip-color-danger,
.small.chip-color-warning,
.small.chip-color-tertiary,
.small.chip-color-secondary,
.small.chip-color-primary,
.small.chip-color-dark {
  padding: 4px 8px 4px 8px;
  font-size: 14px !important;
}
.chip-base.small span,
.small.chip-color-danger span,
.small.chip-color-warning span,
.small.chip-color-tertiary span,
.small.chip-color-secondary span,
.small.chip-color-primary span,
.small.chip-color-dark span {
  font-size: 0.75rem;
}
.chip-color-dark {
  background-color: #e0e0e0;
  color: black;
}
.chip-color-primary {
  background-color: #d4ecff;
  color: #0c8ce9;
}
.chip-color-secondary {
  background-color: #fff0c6;
  color: #d59b00;
}
.chip-color-tertiary {
  background-color: #ffd5eb;
  color: #c80064;
}
.chip-color-warning {
  background-color: var(--ion-color-danger);
  color: white;
}
.chip-color-danger {
  background-color: white;
  color: #ff007f;
}
/*# sourceMappingURL=product-label.component-FLM3CUOV.css.map */
